/* eslint-disable react/destructuring-assignment */
import type { FC, ReactElement } from "react"

import GroupContainer from "./containers/coaching-sessions.container.group"
import IndividualContainer from "./containers/coaching-sessions.container.individual"
import { ECoachingSessionsApiMode as EApiMode, type TCoachingSessionsEntityProps as TEntityProps } from "./types"

const CoachingSessionsEntity: FC<TEntityProps> = (props: TEntityProps): ReactElement =>
    props.apiMode === EApiMode.Group ? <GroupContainer {...props} /> : <IndividualContainer {...props} />

CoachingSessionsEntity.displayName = "CoachingSessionsEntity"

export { CoachingSessionsEntity }
